import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
import HintTooltip from 'components/HintTooltip';

// Wraps a total mortality value with a hover breakdown by death type (Barn Sheets lists and group header).
// showTreated: the ABF treated-deaths row, by the group's abf_tracking or the company's for farm totals
const MortalityBreakdown = ({ children, acute, chronic, euthanasia, treated, showTreated }) => (
  <span className="position-relative">
    {children}
    <HintTooltip attachToBody showBelow arrowed>
      <div><FormattedMessage id="general.deaths.acute" />: {acute}</div>
      <div><FormattedMessage id="general.deaths.chronic" />: {chronic}</div>
      <div><FormattedMessage id="general.deaths.euthanasia" />: {euthanasia}</div>
      {showTreated && (
        <div><FormattedMessage id="general.treated" />: {treated}</div>
      )}
    </HintTooltip>
  </span>
);

MortalityBreakdown.propTypes = {
  children: T.node.isRequired,
  acute: T.number,
  chronic: T.number,
  euthanasia: T.number,
  treated: T.number,
  showTreated: T.bool,
};

MortalityBreakdown.defaultProps = {
  acute: 0,
  chronic: 0,
  euthanasia: 0,
  treated: 0,
  showTreated: false,
};

export default MortalityBreakdown;
